import{useEffect} from 'react'
import useGetProductsInfo from '../hooks/useGetProductsInfo'
import WhiteTilesSlier from './WhiteTilesSlider'
import Spinner from '../UI/Spinner'


const WhiteTileWrapper = props => {
//console.log('props.skuArr:',props.skuArr)
let homepageData
let bgImage
let headerColor
props.wrapperInfo && props.wrapperInfo !== undefined ? homepageData = props.wrapperInfo : homepageData = null
homepageData && homepageData !== undefined ? bgImage = homepageData.background_image : bgImage = null
homepageData && homepageData !== undefined ? headerColor = homepageData.header_bg_color : headerColor = null

const {getProductInfoFunc,productsInfo,isLoadingProductInfo} = useGetProductsInfo()
const filteredNumSKus = props.skuArr.filter(Number)
const filteredNanSKus = props.skuArr.filter(isNaN)
//console.log('filteredNumSKus:',filteredNumSKus,'filteredNanSKus:',filteredNanSKus,filteredNanSKus.length)
const skuArr_string = filteredNumSKus.toString().split(',')

useEffect(() => {
      getProductInfoFunc(skuArr_string)
}, [])

const defualtData = {'sku':'10000000'}
let categoryArr = []

if(productsInfo && productsInfo !== undefined && filteredNanSKus.length > 0) {
  //console.log('----------------------')
  filteredNanSKus.forEach(() => {
    productsInfo.push(defualtData)
  });
 
}else if (filteredNumSKus.length === 0 && filteredNanSKus.length > 0){
  //console.log('just category')
  filteredNanSKus.forEach(() => {
    categoryArr.push(defualtData)
  });
  
}

//console.log('productsInfo with default data :',productsInfo,categoryArr)


const filteredSkuInfo = props.skusInfo.filter(info => {
  return props.skuArr.indexOf(info.sku) > -1
})



let combinedData
productsInfo && productsInfo !== undefined ? combinedData = filteredSkuInfo.map((item,i) => Object.assign({},item,productsInfo[i])) : combinedData = filteredSkuInfo.map((item,i) => Object.assign({},item,categoryArr[i]))
//console.log('combinedData:',combinedData)




if(productsInfo && productsInfo !== undefined ){
  combinedData.sort((a,b) => {
    return a.position - b.position
  }) 
}else if( categoryArr !== undefined && categoryArr.length > 0){
  combinedData.sort((a,b) => {
    return a.position - b.position
  }) 
}



//console.log('ordered data:',combinedData,combinedData.length)

let productsInfo_top
let productsInfo_bottom

if(combinedData && combinedData !== null && combinedData.length > 3 && combinedData.length < 9 ){
  //console.log('show just top','combinedData.length' ,combinedData.length )
  productsInfo && productsInfo !== undefined || categoryArr.length > 0 ? productsInfo_top = combinedData : productsInfo_top = null
  productsInfo_bottom = null
}else if(combinedData && combinedData !== null  && combinedData.length > 7 && combinedData.length < 13){
  //console.log('devide it by 2','combinedData.length' ,combinedData.length)
  productsInfo && productsInfo !== undefined || categoryArr.length > 0 ? productsInfo_top = combinedData.slice(0,Math.ceil(combinedData.length/2)) : productsInfo_top = null
  productsInfo && productsInfo !== undefined || categoryArr.length > 0 ? productsInfo_bottom = combinedData.slice(Math.floor(combinedData.length/2  ,combinedData.length)) :productsInfo_bottom = null
}else if (combinedData && combinedData !== null  && combinedData.length > 11){
  //console.log('show 8 at top and the rest at bottom','combinedData.length' ,combinedData.length)
  productsInfo && productsInfo !== undefined || categoryArr.length > 0 ? productsInfo_top = combinedData.slice(0,8) : productsInfo_top = null
  productsInfo && productsInfo !== undefined || categoryArr.length > 0 ? productsInfo_bottom = combinedData.slice(8,combinedData.length) : productsInfo_bottom = null
}
//console.log('productsInfo_top:',productsInfo_top,'productsInfo_bottom:',productsInfo_bottom)
const showArrows = combinedData.length > 4

return(
  isLoadingProductInfo ? <Spinner/> :
  combinedData && combinedData !== null && combinedData.length > 3 ? (
    <div className="ggds">
      <div className="container marg-top-20 marg-bottom-20">
        <div>
            {homepageData && homepageData !== undefined && homepageData.slider_title !== undefined && homepageData.slider_title !== '' ? <h1 className="text-center" style={homepageData.title_color !== "" ? {color: homepageData.title_color} : null }>{homepageData.slider_title}</h1> : <h1 className="text-center">Check Out These Great Deals!</h1>}
            <WhiteTilesSlier  productsInfo={productsInfo_top} bgImage={bgImage} pageUrl={props.pageUrl} headerColor={headerColor} autoPlaySpeed='3500' showArrows ={showArrows}/>
            <WhiteTilesSlier  productsInfo={productsInfo_bottom} bgImage={bgImage} pageUrl={props.pageUrl} headerColor={headerColor} autoPlaySpeed='4000' showArrows ={showArrows}/>
          </div>
        
      </div>
    </div>
 
) : null 

    )


}

export default WhiteTileWrapper

